import { BaseService } from './base.service';
import { CustomResponseEntity, PaginationParams } from '../types/common';
import { TrainingTopicDto, CreateTrainingTopicDto, UpdateTrainingTopicDto } from '../types/dtos/training';
import { api } from '../client/axiosClient';

/**
 * TrainingTopicService handles CRUD operations for training topics.
 *
 * URL Pattern: /api/v1/trainings/{trainingId}/modules/{moduleId}/topics
 * Organization context is provided via X-Organization-Id header (injected by axiosClient).
 *
 * Migration: The organizationId parameter has been removed from URL paths. The backend
 * extracts organization context from the X-Organization-Id header for tenant scoping.
 *
 * VAL-FE-006: Training Service Works with Header-Based Auth
 * The axiosClient automatically includes X-Organization-Id header from localStorage,
 * which the backend uses for tenant context validation via TenantContextHolder.
 *
 * @param _organizationId - Deprecated: Organization ID (no longer used, kept for backward compatibility)
 * @param trainingId - Parent training UUID for nested resource path
 * @param moduleId - Parent module UUID for nested resource path
 */
export class TrainingTopicService extends BaseService<
  TrainingTopicDto,
  CreateTrainingTopicDto,
  UpdateTrainingTopicDto
> {
  /**
   * @param _organizationId - Deprecated: Organization ID (no longer used, kept for backward compatibility)
   * @param trainingId - Parent training UUID for nested resource path
   * @param moduleId - Parent module UUID for nested resource path
   */
  constructor(_organizationId: string, trainingId: string, moduleId: string) {
    super(`/api/v1/trainings/${trainingId}/modules/${moduleId}/topics`);
  }

  findAll(params?: PaginationParams): Promise<CustomResponseEntity<TrainingTopicDto[]>> {
    return api.get(this.baseUrl, { params });
  }
}

/**
 * Factory function to create a TrainingTopicService instance
 * @param _organizationId - Deprecated: Organization ID (no longer used, kept for backward compatibility)
 * @param trainingId - Parent training UUID for nested resource path
 * @param moduleId - Parent module UUID for nested resource path
 */
export const createTrainingTopicService = (
  _organizationId: string, 
  trainingId: string, 
  moduleId: string
) => new TrainingTopicService(_organizationId, trainingId, moduleId);

